var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.9 20c0 9.87 7.2 18.13 16.66 19.73l.13-.1V25.6h-5.06V20h4.93v-4.4c0-4.93 3.2-7.73 7.73-7.73 1.47 0 2.94.13 4.4.4v5.06h-2.53c-2.4 0-2.93 1.2-2.93 2.8V20h5.33l-.93 5.6h-4.27v14.11A20.05 20.05 0 0 0 40.89 20c0-10.93-9.06-20-20-20C9.96 0 .9 9.07.9 20"
  })));
};
export default SvgIconFacebook;